import type { VariantSanityImage } from '../product-variant.types';
import { urlFor } from '@/sanity/lib/image';

/**
 * Converts a Sanity image to the format expected by VariantItem
 */
export const toImageField = (
  img: VariantSanityImage | null | undefined,
): {
  alt?: string;
  bynderImage?: {
    alt?: string;
  };
  asset: { url: string };
} => {
  try {
    const directUrl = img?.asset?.url || img?.url;

    if (!img?.asset?._ref) {
      return {
        alt: img?.alt,
        bynderImage: img?.bynderImage,
        asset: { url: directUrl || '' },
      };
    }

    const url = urlFor(img).width(800).quality(85).url();
    return {
      alt: img.alt,
      bynderImage: img.bynderImage,
      asset: { url },
    };
  } catch {
    return {
      alt: img?.alt,
      bynderImage: img?.bynderImage,
      asset: { url: img?.asset?.url || img?.url || '' },
    };
  }
};
